import React from 'react';
import GitProviderInstructionsLayout from './GitProviderInstructionsLayout';
import PatGitProviderInstructions from './PatGitProviderInstructions';
import OAuthGitProviderInstructions from './OAuthGitProviderInstructions';
import GitTypes from 'common/constants/GitTypes';

const GitProviderInstructions = ({
  isPat,
  provider = GitTypes.GITHUB,
  scopes
}) => (
  <GitProviderInstructionsLayout>
    {isPat ? (
      <PatGitProviderInstructions provider={provider} scopes={scopes} />
    ) : (
      <OAuthGitProviderInstructions provider={provider} />
    )}
  </GitProviderInstructionsLayout>
);

export default GitProviderInstructions;
